const scope = "officer/";

export const fetch_paginated_officers_saga = `${scope}fetch_paginated_officers`;
export const fetch_officer_by_id_saga = `${scope}fetch_officer_by_id`;
export const create_new_officer_saga = `${scope}fetch_create_new_officer`;
export const update_officer_saga = `${scope}update_new_officer_saga`;
export const delete_officer_saga = `${scope}delete_officer_saga`;
export const reset_password_officer_saga = `${scope}reset_password_officer_saga`;
